import React, {useCallback} from 'react';
import {capitalize, getCssSizeValue, isFunction} from "@/utils/utils";
import Text from "@/components/common/Text";
import styled from "styled-components";
import ArrowsNavigation from "@/components/common/ArrowsNavigation";
import {BREAKPOINTS} from "@/styles/themeSettings";


const Wrapper = styled.div`
	display: flex;
	margin-bottom: ${getCssSizeValue(54)};
	justify-content: space-between;
	.arrow-navigation{
		 .simple-icon-button, .box{
             border: solid 1px black;
		 }
	}
    @media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
        justify-content: end;
        .text.label{
            margin: 0 auto 0 50%;
            translate: -50% 0;
        }
    }
`

const Toolbar = ({ label='', navigationText='', onNavigate=()=>{}, date=new Date(), ...props }) => {
	const capitalizedLabel = capitalize(label)
	const handleNavigate = useCallback((next=false) => {
		if(!isFunction(onNavigate)) return
		const updated = new Date(date);
		if(next){
			updated.setMonth(updated.getMonth() + 1)
		} else {
			updated.setMonth(updated.getMonth() - 1)
		}
		onNavigate(null,updated)
	},[onNavigate, date])

	return (
		<Wrapper className={`toolbar`}>
			{/*<span/>*/}
			<Text className="typo-borna-66 label">
				{capitalizedLabel}
			</Text>
			<ArrowsNavigation
				boxText={navigationText}
				leftButtonClickHandler={() => handleNavigate(false)}
				rightButtonClickHandler={() => handleNavigate(true)}
			/>
		</Wrapper>
	);
};

export default Toolbar;
